import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/blog", label: "Blog" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl" style={{ background: "rgba(252,250,248,0.82)", borderBottom: "1px solid var(--border-soft)" }} data-testid="site-header">
      <div className="container-soft flex items-center justify-between py-5">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="font-display text-2xl tracking-tight" style={{ color: "var(--text-primary)" }}>Sudiksha Kulharia</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} className={({isActive}) =>
              `text-sm tracking-wide transition-colors ${isActive ? "text-[color:var(--primary-deep)]" : "text-[color:var(--text-secondary)] hover:text-[color:var(--text-primary)]"}`
            } data-testid={`nav-${n.label.toLowerCase()}`}>
              {n.label}
            </NavLink>
          ))}
          <Link to="/booking" className="text-sm tracking-wide rounded-full px-5 py-2.5 transition-colors" style={{ background: "var(--primary)", color: "#fff" }} data-testid="nav-book-btn">
            Book a Consultation
          </Link>
        </nav>
        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Toggle menu">
          {open ? <X size={22}/> : <Menu size={22}/>}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t" style={{ borderColor: "var(--border-soft)" }}>
          <div className="container-soft py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.to === "/"} className="py-2 text-base" style={{ color: "var(--text-secondary)" }} data-testid={`mnav-${n.label.toLowerCase()}`}>
                {n.label}
              </NavLink>
            ))}
            <Link to="/booking" className="mt-2 rounded-full px-5 py-3 text-center" style={{ background: "var(--primary)", color: "#fff" }} data-testid="mnav-book-btn">
              Book a Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
